import { ApolloError, WatchQueryFetchPolicy } from '@apollo/client';
import { BiddingSetting, useGetBiddingSettingQuery } from '../api';

const useBiddingSetting = (
    fetchPolicy: WatchQueryFetchPolicy = 'cache-first'
): {
    biddingSetting: BiddingSetting | undefined;
    loading: boolean;
    error?: ApolloError;
    refetch: () => void;
} => {
    const { data, loading, error, refetch } = useGetBiddingSettingQuery({ fetchPolicy });

    return {
        biddingSetting: data?.biddingSetting,
        loading,
        error: error ?? undefined,
        refetch: () => {
            refetch();
        },
    };
};

export default useBiddingSetting;
